/* eslint-disable no-unexpected-multiline */
import { animate, style, transition, trigger } from '@angular/animations';
import {
  AfterViewInit,
  Component,
  ElementRef,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
  OnInit,
  ChangeDetectorRef,
  AfterViewChecked,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { DashboardToken } from '@shared-store/base.action';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import {
  MenuItem,
  SuccessErrorMessages,
} from 'src/app/shared-resources/interfaces/base-core-services.interface';
import { HttpErrorHandlerService } from 'src/app/shared-resources/services/http-error-handling.service';
import { LazyLoaderService } from 'src/app/shared-resources/services/lazy-loader.service';
import { MenuService } from 'src/app/shared-resources/services/menu.service';
import {
  BaseSharedState,
  RdmModuleLoaded,
} from 'src/app/shared-resources/store/base.state';
import { LoginService } from '../services/login.service';
import * as _ from 'lodash';
import { BaseApp } from '@subscription-destroyer';
import { RDMClientService } from '@shared-services/rdm-client.service';
import { LayoutService } from 'src/app/shared-resources/services/layout.service';

@Component({
  selector: 'app-layout-default',
  templateUrl: './layout-default.component.html',
  styleUrls: ['./layout-default.component.less'],
  providers: [BaseApp],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
// eslint-disable-next-line indent
export class LayoutDefaultComponent implements AfterViewInit, OnInit, AfterViewChecked {
  public isCollapsed = JSON.parse(sessionStorage.getItem('siderCollapsed') || 'false');
  public isHoverExpanded = false;
  public isOpen = false;
  public showMessage = false;
  public isScroll = false;
  public visible = false;
  public nzTitle: boolean;
  public menu: MenuItem[] = [];
  public selectedMenu: MenuItem;
  public loading!: boolean;
  public triggerTemplate: TemplateRef<void> | null = null;
  public errorMessages: string[] = [];
  public successMessage = '';
  public isDialog = false;
  public isLanding = true;
  public showSubMenu = false;
  public menuItems: any = [];
  public selectedModule: MenuItem;
  // public showBiReports = false;
  public loadingCheck: any;

  @ViewChild('widgetsContent', { read: ElementRef })
  public widgetsContent: ElementRef<any>;
  @ViewChild('trigger') customTrigger: TemplateRef<void>;

  public rdmLoadedForModule$ = new BehaviorSubject<Map<string, RdmModuleLoaded>>(new Map());
  public reloadComponentAfterRefresh: OnInit | any;
  winWidth: boolean = true;

   menuIconMap: Record<string, string> = {    
    'ics.menu.tariffmgmt.tariff': 'assets/img/Menu/TariffManagement/generaltariff.svg',
    'ics.menu.tariffmgmt.tariff.create' : 'assets/img/Menu/Generic/create.svg',
    'ics.menu.tariffmgmt.tariff.search' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.tariffmgmt.tariff.upload' : 'assets/img/Menu/Generic/upload.svg',
    'ics.menu.tariffmgmt.tariff.uploaded' : 'assets/img/Menu/Generic/searchupload.svg',
    'menu.intelligence.tariffManagement.preferential' : 'assets/img/Menu/TariffManagement/preferential.svg',
   'menu.intelligence.tariffManagement.preferential.create' : 'assets/img/Menu/Generic/create.svg',
    'menu.intelligence.tariffManagement.preferential.search' : 'assets/img/Menu/Generic/search.svg',
    'menu.intelligence.tariffManagement.preferential.upload' : 'assets/img/Menu/Generic/upload.svg',
    'menu.intelligence.tariffManagement.preferential.uploaded' : 'assets/img/Menu/Generic/searchupload.svg',
    'menu.intelligence.tariffManagement.ruling' : 'assets/img/Menu/TariffManagement/clasifficationruling.svg',
   'menu.intelligence.tariffManagement.ruling.create' : 'assets/img/Menu/Generic/create.svg',
    'menu.intelligence.tariffManagement.ruling.search' : 'assets/img/Menu/Generic/search.svg',
     'menu.tariffManagement.tariffcontrol': 'assets/img/Menu/TariffManagement/tariffcontrol.svg',
    'menu.tariffManagement.tariffcontrol.create' : 'assets/img/Menu/Generic/create.svg',
    'menu.tariffManagement.tariffcontrol.search' : 'assets/img/Menu/Generic/search.svg',
    'menu.tariffManagement.tariffcontrol.uploadBulk' : 'assets/img/Menu/Generic/upload.svg',
    'menu.tariffManagement.tariffcontrol.uploaded' : 'assets/img/Menu/Generic/searchupload.svg',
    'ics.menu.declaration.declaration' : 'assets/img/Menu/Declaration/declaration.svg',
    'ics.menu.declaration.declaration.view' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.worklistmgmt.worklist' : 'assets/img/Menu/Worklist/worklist.svg',
    'ics.menu.worklistmgmt.worklist.worklist' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.usermgmt.usermgmt' : 'assets/img/Menu/Users/usermanagament - menu.svg',
    'ics.menu.usermgmt.usermgmt.users' : 'assets/img/Menu/Users/usermanagament.svg',
    'ics.menu.usermgmt.usermgmt.roles' : 'assets/img/Menu/Users/role.svg',
    'ics.menu.intelligencemgmt.profilemgmt' : 'assets/img/Menu/Intelligence/profilemanagement.svg',
    'ics.menu.intelligencemgmt.profilemgmt.create' : 'assets/img/Menu/Generic/create.svg',
    'ics.menu.intelligencemgmt.profilemgmt.search' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.intelligencemgmt.riskregister' : 'assets/img/Menu/Intelligence/riskregister.svg',
    'ics.menu.intelligencemgmt.riskregister.create' : 'assets/img/Menu/Generic/create.svg',
    'ics.menu.intelligencemgmt.riskregister.serach' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.intelligencemgmt.settings' : 'assets/img/Menu/Intelligence/settings.svg',
    'ics.menu.intelligencemgmt.settings.riskAssmt' : 'assets/img/Menu/Intelligence/riskassessment.svg',    
    'ics.menu.intelligencemgmt.favourite-list' : 'assets/img/Menu/Intelligence/favorite.svg',
    'ics.menu.intelligencemgmt.favourite-list.create' : 'assets/img/Menu/Generic/create.svg',
    'ics.menu.intelligencemgmt.favourite-list.search' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.intelligencemgmt.trustedTrader' : 'assets/img/Menu/Intelligence/trustedtrader.svg',
    'ics.menu.intelligencemgmt.trustedTrader.search' : 'assets/img/Menu/Generic/search.svg',   
    
     'ics.menu.customsvaluation.valuation': 'assets/img/Menu/Valuation/valuationprofile.svg',
    'ics.menu.customsvaluation.valuation.search' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.customsvaluation.valuation.create' : 'assets/img/Menu/Generic/create.svg',
    'ics.menu.customsvaluation.valuation.calculator' : 'assets/img/Menu/Valuation/valuationcalaculator.svg',

    'ics.menu.customsvaluation.masterdata': 'assets/img/Menu/Valuation/valuationmaster.svg',
     'ics.menu.customsvaluation.masterdata.gold.price.create' : 'assets/img/Menu/Valuation/gold.svg',
    'ics.menu.customsvaluation.masterdata.gold.price.search' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.customsvaluation.masterdata.vehicle.price.create' : 'assets/img/Menu/Valuation/vehicle.svg',
    'ics.menu.customsvaluation.masterdata.vehicle.price.search' : 'assets/img/Menu/Generic/search.svg',
    'ics.menu.customsvaluation.masterdata.vehicle.price.upload' : 'assets/img/Menu/Generic/upload.svg',

    'ics.menu.customsvaluation.valueResult': 'assets/img/Menu/Valuation/valuationresult.svg',
     'ics.menu.customsvaluation.valueResult.declaration' : 'assets/img/Menu/Generic/search.svg',

     'ics.menu.customsvaluation.additional': 'assets/img/Menu/Valuation/additionalinfo.svg',
     'ics.menu.customsvaluation.additional.create-indicator' : 'assets/img/Menu/Generic/create.svg',
     'ics.menu.customsvaluation.additional.search-indicator' : 'assets/img/Menu/Generic/search.svg',
     'ics.menu.customsvaluation.additional.upload-indicator' : 'assets/img/Menu/Generic/upload.svg',
     'ics.menu.customsvaluation.additional.indicator.upload-view' : 'assets/img/Menu/Generic/searchupload.svg',
     
     'ics.menu.customsvaluation.additional.create-hs-code-mapping' : 'assets/img/Menu/Valuation/hscodemapping.svg',
     'ics.menu.customsvaluation.additional.search-hs-code-mapping' : 'assets/img/Menu/Generic/search.svg',
     'ics.menu.customsvaluation.additional.upload-hs-code-mapping' : 'assets/img/Menu/Generic/upload.svg',

     'ics.menu.system-admin.masterData': 'assets/img/Menu/SystemAdmin/Masterdata.svg',
     'ics.menu.system-admin.masterData.create': 'assets/img/Menu/Generic/create.svg',
     'ics.menu.system-admin.masterData.search': 'assets/img/Menu/Generic/search.svg',
     'ics.menu.system-admin.masterData.uploaded': 'assets/img/Menu/Generic/searchupload.svg',

     'ics.menu.refdata.exchangerate' : 'assets/img/Menu/SystemAdmin/Exchangerate.svg',
     'ics.menu.system-admin.exchangerate.uploaded' : 'assets/img/Menu/Generic/searchupload.svg',
     'ics.menu.system-admin.exchangerate.viewall' : 'assets/img/Menu/Generic/search.svg',

     'ics.menu.system-admin.emailTemplate' : 'assets/img/Menu/SystemAdmin/Email-template.svg',
     'ics.menu.system-admin.emailTemplate.search' : 'assets/img/Menu/Generic/search.svg',

    //  'ics.menu.reports.customReports' : 'assets/img/Menu/Reports/Report-menu.svg',
    //  'ics.menu.reports.customReports.declarationReports' : 'assets/img/Menu/Reports/Report-menu.svg',
  };
 
  getMenuIcon(label: string): string | null {
    return this.menuIconMap[label] || null;
  } 
  constructor(
    public menuService: MenuService,
    public lazyloaderService: LazyLoaderService,
    public loginservice: LoginService,
    public rdmClient: RDMClientService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private subscribtions: BaseApp,
    private router: Router,
    private httpMessages: HttpErrorHandlerService,
    private store: Store,
    private layoutService: LayoutService
  ) { }

  public isLoading!: Subject<boolean>;
  public showLoader = false;

  async ngOnInit(): Promise<void> {
    await this.initStoreData();
    this.isLoading = this.lazyloaderService.isLoading;
    this.subscribtions.subs.add(this.rdmClient.lodingSubscriber.subscribe((res) => {
      this.loadingCheck = res;
    }));
    this.subscribtions.subs.add(
      this.layoutService.navigateTo$.subscribe((url: string) => {
        const matchedModule = this.menuItems.find((m: any) => url.includes(m.link));
        if (!matchedModule) return;
        this.isHoverExpanded = false;
        if (this.selectedModule) {
          const i = _.findIndex(this.menuItems, ['label', this.selectedModule.label]);
          if (i >= 0) this.menuItems[i].selected = false;
        }
        const idx = _.findIndex(this.menuItems, ['label', matchedModule.label]);
        if (idx >= 0) this.menuItems[idx].selected = true;
        this.selectedModule = matchedModule;
        this.showSubMenu = matchedModule.operationName !== 'dashboard';
        sessionStorage.setItem('selectedModuleOnRefresh', JSON.stringify(this.selectedModule));
        sessionStorage.setItem('modules', JSON.stringify(this.menuItems));
        this.router.navigateByUrl(url);
      })
    );
    this.subscribtions.subs.add(
      this.activatedRoute.queryParams.subscribe((res) => {
        this.isDialog = res.isDialog ? true : false;
      })
    );
    const rawModules = sessionStorage.getItem('modules');
    const listOfModules = rawModules ? JSON.parse(rawModules) : null;

    if (!listOfModules || listOfModules.length === 0) {
      // New tab scenario: sessionStorage is empty but cookies still have auth
      const targetUrl = this.router.url;
      this.loginservice.fetchUserMenuFromServer().subscribe({
        next: (modules: any[]) => {
          this.menuItems = [...modules];
          this.restoreMenuFromUrl(targetUrl);
        },
        error: () => this.router.navigateByUrl('/login')
      });
    } else {
      this.menuItems = [...listOfModules];
      this.restoreMenuFromUrl(this.router.url);
    }
    this.subscribtions.subs.add(
      this.router.events.subscribe((event: any) => {
        // this.showBiReports = window.location.href.indexOf('/power-bi') === -1 ? false : true;
        if (event.url) {
          const moduleRoute = event.url.toString().replace('/app/', '').split('/')[0];
          this.lazyloaderService.show(moduleRoute);
          this.afterClose();
          if (event.url === '/app/landing') {
            this.showSubMenu = false;
            if (document.getElementsByClassName('router-content')[0])
              document
                .getElementsByClassName('router-content')[0]
                ?.setAttribute('style', 'margin:0 auto 55px');
          } else if (event.url.startsWith('/app/settings')) {
            this.showSubMenu = false;
          }
          // else if (event.url === '/app/bi-reports/power-bi') {
          //   this.showSubMenu = false;
          //   if (document.getElementsByClassName('router-content')[0])
          //     document
          //       .getElementsByClassName('router-content')[0]
          //       ?.setAttribute(
          //         'style',
          //         'width:100%;max-width :100% ;margin-left:0px'
          //       );
          // }
          else {
            if (document.getElementsByClassName('router-content')[0])
              document
                .getElementsByClassName('router-content')[0]
                ?.setAttribute('style', 'margin-left:0px');
            this.showSubMenu = true;
          }
        }
      })
    );
  }

  private restoreMenuFromUrl(url: string): void {
    const savedModule = sessionStorage.getItem('selectedModuleOnRefresh');
    if (savedModule && !this.isDialog) {
      const selectedModuleData = JSON.parse(savedModule);
      const idx = _.findIndex(this.menuItems, ['label', selectedModuleData.label]);
      if (idx >= 0) this.menuItems[idx].selected = true;
      this.selectedModule = this.menuItems[idx] ?? selectedModuleData;
      this.showSubMenu = this.selectedModule.label !== 'dashboard.menu';
    } else {
      // Derive selected module from the current URL (new tab with no saved state)
      const matched = this.menuItems.find((m: any) => url.includes(m.link));
      if (matched) {
        const idx = _.findIndex(this.menuItems, ['label', matched.label]);
        if (idx >= 0) this.menuItems[idx].selected = true;
        this.selectedModule = this.menuItems[idx];
        this.showSubMenu = matched.operationName !== 'dashboard';
        sessionStorage.setItem('selectedModuleOnRefresh', JSON.stringify(this.selectedModule));
        sessionStorage.setItem('modules', JSON.stringify(this.menuItems));
      }
    }
  }

  traverseToModule(traverseToModule: MenuItem | any): void {
    this.isHoverExpanded = false;
    if (this.selectedModule) {
      const indexOfSelectedModules = _.findIndex(this.menuItems, ['label', this.selectedModule.label]);
      this.menuItems[indexOfSelectedModules].selected = false;
    }
    const indexOfModules = _.findIndex(this.menuItems, ['label', traverseToModule.label]);
    this.menuItems[indexOfModules].selected = true;
    this.selectedModule = traverseToModule;
    this.showSubMenu = traverseToModule.operationName != 'dashboard' ? true : false;
    if (traverseToModule.children.length > 0) {
      const firstVisibleChild = traverseToModule.children.find((c: any) => !c.hide) || traverseToModule.children[0];
      const firstVisibleGrandChild = firstVisibleChild.children?.find((c: any) => !c.hide) || firstVisibleChild.children?.[0];
      firstVisibleChild.selected = true;
      firstVisibleChild.open = true;
      if (firstVisibleGrandChild) {
        firstVisibleGrandChild.selected = true;
        this.router.navigateByUrl(traverseToModule.link + firstVisibleChild.link + firstVisibleGrandChild.link);
      } else {
        this.router.navigateByUrl(traverseToModule.link + firstVisibleChild.link);
      }
    } else {
      this.showSubMenu = false;
      this.router.navigateByUrl(traverseToModule.link);
    }
    sessionStorage.setItem('selectedModuleOnRefresh', JSON.stringify(this.selectedModule))
    sessionStorage.setItem('modules', JSON.stringify(this.menuItems))
  }

  traverseSubMenu(subMenu: MenuItem): void {
    this.router.navigate([this.selectedModule.link + subMenu.link]);
  }

  ngAfterViewInit(): void {
     this.winWidth = window.innerWidth > 1200 ? true : false ;
     //this.isCollapsed = !this.winWidth;
    window.onresize = () =>{
      this.winWidth = window.innerWidth > 1200 ? true : false ;
     // this.isCollapsed = !this.winWidth;
    }
    this.subscribtions.subs.add(
      this.httpMessages
        .getMessages()
        .subscribe((result: SuccessErrorMessages) => {
          if (result.error && result.error.length) {
            this.showMessage = true;
            this.errorMessages = result.error;
            this.successMessage = '';
          } else if (typeof result.success === 'string') {
            this.showMessage = true;
            this.successMessage = result.success;
            this.errorMessages = [];
          }
        })
    )
  }

  onActivate(value: any): void {
    if (this.loading === null) this.reloadComponentAfterRefresh = value;
  }

  open(): void {
    this.isOpen = true;
  }
  openError(): void {
    this.visible = true;
  }
  close(): void {
    this.visible = false;
    this.isOpen = false;
  }

  afterClose(): void {
    if (this.reloadComponentAfterRefresh) {
      this.reloadComponentAfterRefresh.ngOnInit();
      this.reloadComponentAfterRefresh = null;
    }
    this.showMessage = false;
    this.errorMessages = [];
    this.successMessage = '';
  }
  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 150,
      behavior: 'smooth',
    });
  }
  public scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 150,
      behavior: 'smooth',
    });
  }
  onMainMenu(menuItem: MenuItem): void {
    if (menuItem.children && menuItem.children.length === 0) {
      this.menuService.onMainMenu(menuItem);
      this.close();
    } else if (menuItem.children && menuItem.children.length > 0) {
      this.menuService.setMainMenu(menuItem);
      this.menuService.openMenuHandler(menuItem, 'mainmenu');
    }
  }
  onSubMenu(menuItem: MenuItem): void {
    this.menuService.onSubMenu(menuItem);
    this.close();
  }
  onChildMenu(subMenuItem: MenuItem, childMenu: MenuItem): void {
    this.menuService.onChildMenu(subMenuItem, childMenu);
    this.close();
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  async initStoreData() {
    try {
      const rdmLoadedForModule = await firstValueFrom(this.store.select(BaseSharedState.rdmDataLoadedForModule));
      this.rdmLoadedForModule$.next(rdmLoadedForModule);
    } catch (error) {
      console.error('Error loading store data:', error);
    }
  }

  onSiderHover(): void {
    if (this.isCollapsed) {
      this.isHoverExpanded = true;
    }
  }

  onSiderLeave(): void {
    if (this.isHoverExpanded) {
      this.isHoverExpanded = false;
    }
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    sessionStorage.setItem('siderCollapsed', JSON.stringify(this.isCollapsed));
    this.layoutService.setCollapsed(this.isCollapsed);
  }
}
